import {Component, inject, OnInit} from '@angular/core';
import {SmsAssignmentComponent} from "../sms-assignment/sms-assignment.component";
import {BulkActionService} from "../../../service/bulk.action.service";
import {BulkAction} from "../../../model/bulk/bulkAction";
import {HttpErrorResponse} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-bulk-action-detail',
  standalone: true,
  imports: [
    SmsAssignmentComponent
  ],
  templateUrl: './bulk-action-detail.component.html',
  styleUrl: './bulk-action-detail.component.css'
})
export class BulkActionDetailComponent implements OnInit {

  private bulkActionService = inject(BulkActionService);
  private route = inject(ActivatedRoute);

  bulkAction: BulkAction | undefined;

  ngOnInit() {
    this.route.params.subscribe(params => {
      const bulkActionId = params['id'];

      this.bulkActionService.findById(bulkActionId).subscribe({
        next: bulkAction => {
          this.bulkAction = bulkAction;
        },
        error: err => {
          if (err instanceof HttpErrorResponse) {
            console.log(err.status + ' ' + err.message);
          }
        }
      });
    });
  }
}
